import { API } from "../../scripts/api";
import axiosInstance from "../../scripts/axiosInspector";
import * as types from "../constant";

export const handleLoginAction = (userData) => async (dispatch, getState) => {
  try {
    localStorage.setItem("userInfo", JSON.stringify(userData));
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${userData.token}`;

    dispatch({
      type: types.USER_LOGIN_SUCCESS,
      payload: userData,
    });
  } catch (error) {
    dispatch({
      type: types.USER_LOGIN_FAIL,
    });
  }
};

export const handleAllCompany =
  (userInfo, company) => async (dispatch, getState) => {
    dispatch({
      type: types.USER_COMPANIES_REQUEST,
    });
    axiosInstance
      .get(API.user.permissions, {
        headers: {
          Authorization: `Bearer ${userInfo?.token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
          Expires: "0",
          "Accept-Language": "fa-IR",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        },
      })
      .then((res) => {
        if (res?.data?.data?.length > 0) {
          dispatch({
            type: types.USER_COMPANIES_SUCCESS,
            payload: res?.data?.data,
          });
          if (!company) {
            dispatch(
              handleCurrentCompanyAction(
                res?.data?.data[res?.data?.data?.length - 1]
              )
            );
          }
        }
      })
      .catch((err) => {
        dispatch({
          type: types.USER_COMPANIES_FAIL,
        });
      });
  };
export const handleLogOut = () => async (dispatch, getState) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("companyName");
  /* localStorage.removeItem("theme"); */
  window.history.pushState("login", "login", "/");
  dispatch({
    type: types.USER_LOGOUT,
  });
};

export const handleThemeToggle = (data) => async (dispatch, getState) => {
  localStorage.setItem("theme", data);
  dispatch({
    type: types.THEME,
    payload: data,
  });
};
export const handleUserDetails = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.USER_DETAIL,
    payload: data,
  });
};
export const handlePopUpPwaAction = (data) => async (dispatch, getState) => {
  if (data === false) {
    localStorage.setItem("la", `${new Date()}`);
  }
  dispatch({
    type: types.POP_UP_PWA,
    payload: data,
  });
};
export const handleModalAction = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.MODAL_HANDLER,
    payload: data,
  });
};
export const handleCurrentCompanyAction =
  (data) => async (dispatch, getState) => {
    localStorage.setItem("companyName", JSON.stringify(data));
    dispatch({
      type: types.CURRENT_COMPANY,
      payload: data,
    });
  };

export const handleAppVersion = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.APP_VERSION,
    payload: data,
  });
};

/* -------------- sell ------------------ */

export const handleAllProducts = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.ALL_PRODUCTS,
    payload: data,
  });
};
export const handleAllUsers = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.ALL_USERS,
    payload: data,
  });
};
export const handleAllInvoice = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.ALL_INVOICE,
      payload: data,
    });
  } catch (err) {}
};
export const resetAllStateAction = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.RESET_ALL_STATE,
    payload: data,
  });
};

export const handleAllSummeryData = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.CATH_SUMMERY_DATA,
    payload: data,
  });
};
export const resetAllSummeryData = () => async (dispatch, getState) => {
  dispatch({
    type: types.RESET_SUMMERY_DATA,
  });
};

/* -------------------- buy ----------------------- */

export const handleBuyAllProducts = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.BUY_ALL_PRODUCTS,
    payload: data,
  });
};
export const handleBuyAllUsers = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.BUY_ALL_USERS,
    payload: data,
  });
};
export const handleBuyAllInvoice = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: types.BUY_ALL_INVOICE,
      payload: data,
    });
  } catch (err) {}
};
export const resetAllBuyStateAction = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.BUY_RESET_ALL_STATE,
    payload: data,
  });
};

export const handleAllBuySummeryData = (data) => async (dispatch, getState) => {
  dispatch({
    type: types.BUY_CATH_SUMMERY_DATA,
    payload: data,
  });
};
export const resetAllBuySummeryData = () => async (dispatch, getState) => {
  dispatch({
    type: types.BUY_RESET_SUMMERY_DATA,
  });
};
